export const calculatePrice = (reservation, reservationLength, app) => {
    const activeCalendar = app?.state?.activeCalendar;
    
    let settings = {
        price_1day_workday: 20,
        price_1day_weekend: 25,
        price_multiday_workday: 17,
        price_multiday_weekend: 18
    };

    if (activeCalendar && activeCalendar.settings) {
        let calSettings = {};
        if (typeof activeCalendar.settings === 'object') {
            calSettings = activeCalendar.settings;
        } else {
            try {
                calSettings = JSON.parse(activeCalendar.settings);
            } catch (e) {
                console.error("Error parsing calendar settings", e);
            }
        }
        settings = { ...settings, ...calSettings };
    }

    let canoePrice = 0;
    let kanoeCount = parseInt(reservation.kanoe_count) || 0;
    if (kanoeCount === 0) {
        kanoeCount = parseInt(reservation.kanoe_count_info_max) || 0;
    }

    if (!kanoeCount) return 0;

    const startDate = new Date(reservation.start_date);
    const holidays = app.functions.getHolidays({ year: startDate.getFullYear() });

    if (reservationLength === 1) {
        let dayInWeek = startDate.getDay();
        dayInWeek = dayInWeek === 0 ? 7 : dayInWeek;
        let formatedDate = app.functions.formatDate(startDate);
        
        const isHighRate = dayInWeek >= 5 || holidays.includes(formatedDate); // Fri, Sat, Sun or Holiday
        canoePrice = (isHighRate ? settings.price_1day_weekend : settings.price_1day_workday) * kanoeCount;

    } else if (reservationLength > 1) {
        for (var i = 0; i < reservationLength; i++) {
            let currentDate = new Date(startDate);
            currentDate.setDate(currentDate.getDate() + i);
            
            let dayInWeek = currentDate.getDay();
            dayInWeek = dayInWeek === 0 ? 7 : dayInWeek;
            let formatedDate = app.functions.formatDate(currentDate);

            const isHighRate = dayInWeek >= 5 || holidays.includes(formatedDate); // Fri, Sat, Sun or Holiday
            canoePrice += (isHighRate ? settings.price_multiday_weekend : settings.price_multiday_workday) * kanoeCount;
        }
    }
    return canoePrice;
};
